import { CheckBox } from "@shltelemedicine/shl-ui-lib";
import { ChangeEventHandler } from "react";
import {
  EcgActionSeverity,
  IAction,
} from "../../../../../models/ecg.interface";
import {
  getActionHeader,
  getActionIcon,
  getActionTextColor,
} from "../../../../../utils/ecgUtil";
import styles from "./multiEcgAction.module.css";

type MultiEcgActionsProps = {
  actions: IAction[] | undefined;
  onChange: ChangeEventHandler<HTMLInputElement>;
  disabled: boolean;
};

const MultiEcgActions = ({
  actions,
  onChange,
  disabled,
}: MultiEcgActionsProps) => {
  const actionsOrder = [
    EcgActionSeverity.Urgent,
    EcgActionSeverity.Priority,
    EcgActionSeverity.Important,
    EcgActionSeverity.Normal,
    EcgActionSeverity.NA,
  ];

  const getSeveritySection = (
    sectionSeverity: number,
    sectionActions: IAction[]
  ) => {
    const actionHeader = getActionHeader(sectionSeverity);
    const actionHeaderColor = getActionTextColor(sectionSeverity);
    const actionHeaderIcon = getActionIcon(sectionSeverity);
    return sectionActions && sectionActions.length ? (
      <div className="mt-3 mb-3">
        <h5
          style={{ color: actionHeaderColor }}
          className={`capitalized ${styles.sectionHeader} d-flex align-items-center`}
        >
          <img
            className={styles.sectionIcon}
            src={actionHeaderIcon}
            alt={actionHeader}
          />{" "}
          <p className={styles.sectionHeaderText}>{actionHeader}</p>
        </h5>
        {sectionActions.map((action) => (
          <CheckBox
            key={action.key}
            type="radio"
            name={action.key}
            checked={action.value}
            label={action.displayName}
            onChange={onChange}
            disabled={disabled}
            className={`${styles.radioBtn} align-items-start mb-1`}
          />
        ))}
      </div>
    ) : null;
  };

  const getUnknownActions = () =>
    actions?.filter(
      ({ severity }) => severity && !actionsOrder.includes(severity)
    ) || [];

  return actions?.length ? (
    <>
      {actionsOrder.map((sectionSeverity) => {
        const sectionActions = actions.filter(
          ({ severity }) => severity === sectionSeverity
        );
        return getSeveritySection(sectionSeverity, sectionActions);
      })}
      {/* RENDER UNKNOWN SEVERITIES */}
      {getSeveritySection(EcgActionSeverity.NA, getUnknownActions())}
    </>
  ) : (
    <></>
  );
};

export default MultiEcgActions;
